/* eslint-disable @typescript-eslint/naming-convention */
import {Entity} from 'app/core/main.entity';
import {FormElementSize, FormElementType} from '../enums';
import {FormElementValidation} from './formElementValidation.entity';
import {FormElementVisibility} from './formElementVisibility.entity';
import 'reflect-metadata';
import {Type} from 'class-transformer';

export abstract class FormElement extends Entity {
  title?: string = null;
  slug: string;
  placeholder?: string = null;
  type: FormElementType = null;
  elementSize?: FormElementSize = 'full';

  @Type(() => FormElementValidation)
  validation?: FormElementValidation[] = [];

  @Type(() => FormElementVisibility)
  hideIf?: FormElementVisibility = null;
}

export class FormElementConfiguration extends Entity {

}
